import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const addressesRoutes: Routes = [
  {
    path: 'addresses',
    loadComponent: () =>
      import('./addresses.component').then((c) => c.AddressesComponent),
    canActivate: [AuthGuard],
  },
];
